module.exports = __webpack_public_path__ + "static/media/StarTimes_PanAfrica.f332ce3d.png";